import { Lang } from '@debbie/common/dist/lang/Lang.js';
import * as React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { setToken } from './auth/actions.js';
import { select as selectCreditor } from './creditors/actions.js';
import { select as selectExclusiveContent } from './exclusiveContent/actions.js';
import { authToken, currentLang, exclusiveContent, populateInternal, selectedCreditorId, setDispatch, } from './internal.js';
import { setLang } from './lang/actions.js';
import { init } from './socket.js';
import store from './store.js';
import { getTenantId, initTenantId } from './tenant/selected.js';
export const Provider = (props) => {
    const [isLoaded, setIsLoaded] = React.useState(false);
    React.useEffect(() => {
        const loadApp = async () => {
            setDispatch(store.dispatch);
            await populateInternal();
            initTenantId();
            const tenantId = getTenantId();
            authToken && authToken.length > 0 && setToken(authToken);
            selectedCreditorId && selectCreditor(selectedCreditorId);
            exclusiveContent?.length > 0 && selectExclusiveContent(exclusiveContent);
            setLang(currentLang || Lang.da);
            if (authToken && tenantId) {
                init(authToken, tenantId);
            }
            setIsLoaded(true);
        };
        loadApp();
    }, []);
    return ((isLoaded && (React.createElement(ReduxProvider, { store: store }, props.children))) || React.createElement(React.Fragment, null));
};
export default Provider;
//# sourceMappingURL=Provider.js.map